export default __webpack_public_path__ + "static/media/cyan1.c7225f31.png";